import React, { useState, useEffect } from "react";
import "./App.css";
import TermsConditions from "./components/footer_components/TermsConditions";
import {
  Route,
  Switch,
  withRouter,
  useHistory,
  useLocation,
} from "react-router-dom";
import BookNow from "./components/bookashoot_components/BookNow";
import privacyPolicy from "./components/footer_components/PrivacyPolicy";
import CancPolicy from "./components/footer_components/CancPolicy";
import PhotographerLogin from "./components/login_components/PhotographerLogin";
import PhotoshootServices from "./components/homePage_components/PhotoshootServices";
import PaymentForm from "./components/bookashoot_components/PaymentForm";
import OTP from "./components/bookashoot_components/OTP.jsx";
import CityHome from "./components/CityHome_components/CityHome";
import Career from "./components/footer_components/Career";
import BecomeFodrixographer from "./components/footer_components/BecomeFodrixographer";
import BecomePartner from "./components/footer_components/BecomePartner";
import ContactUs from "./components/footer_components/contactUs";
import Testinomials from "./components/testinomial_components/Testinomials";
import NewDashboard from "./components/New-Dashboard__components/NewDashboard";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/Dashboard_components/Authentication/ProtectedRoute";
import Footer from "./components/footer_components/Footer";
import OfferAlert from "./mainUtils/OfferAlert";
import NewUserDashboard from "./components/Dashboard_components/NewUserDashboard";
import PackageModal from "./components/package_modal/PackageModal";
import BackToTop from "./components/BackToTop";
import { Action } from "history";
import loginjs from "./components/login_components/loginjs";
import Login from "./components/login_components/Login";
import { Redirect } from "react-router";
import { HomeProvider } from "./context";

// global.loggedIn = true;

function App() {
  const history = useHistory();
  const location = useLocation();
  const [pathname, setPathname] = useState(history.location.pathname);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("auth")));

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("profile")));
  }, [location]);

  history.listen((location, Action) => {
    window.scrollTo(0, 0);
  });
  return (
    <HomeProvider>
      {history.location.pathname.includes("dashboard") ||
      history.location.pathname.includes("userDashboard") ||
      history.location.pathname.includes("portfolio") ? null : (
        <>
          {/* <OfferAlert /> */}
          <Navbar />
        </>
      )}
      {history.location.pathname.includes("portfolio") ? <Navbar /> : null}

      <Switch>
        <Route exact path="/tNc" component={TermsConditions} />

        <Route exact path="/book" component={BookNow} />
        <Route exact path="/privacyPolicy" component={privacyPolicy} />
        <Route exact path="/cancellationPolicy" component={CancPolicy} />
        <Route exact path="/pLogin" component={PhotographerLogin} />

        <Route exact path="/payment" component={PaymentForm} />
        <Route exact path="/OTP" component={OTP} />
        <Route exact path="/City_Home" component={CityHome} />
        <Route
          exact
          path="/BecomeFodrixographer"
          component={BecomeFodrixographer}
        />
        <Route exact path="/Career" component={Career} />
        <Route exact path="/BecomePartner" component={BecomePartner} />
        <Route exact path="/contact" component={ContactUs} />
        <Route exact path="/testimonial" component={Testinomials} />
        <Route
          exact
          path="/photoshoot_services"
          component={PhotoshootServices}
        />

        <ProtectedRoute
          exact
          path="/dashboard/profile"
          element={NewDashboard}
        />

        <Route exact path="/book_package" component={PackageModal} />

        <ProtectedRoute
          exact
          path="/userdashboard"
          component={NewUserDashboard}
        ></ProtectedRoute>

        <ProtectedRoute
          exact
          path="/dashboard"
          component={NewDashboard}
        ></ProtectedRoute>
      </Switch>
      <BackToTop />
      {history.location.pathname.includes("dashboard") ||
      history.location.pathname.includes("userDashboard") ? null : (
        <Footer />
      )}
    </HomeProvider>
  );
}

export default withRouter(App);
